export class CountryEntity {
  id: string;
  code: string;
  name: string;

  constructor(id: string, code: string, name: string) {
    this.id = id;
    this.code = code;
    this.name = name;
  }
}
